import Agent from './components/elements/Agent'
import Button from './components/elements/Button'
import BuyerProfiles from './components/elements/BuyerProfiles'
import CampaignDocuments from './components/elements/CampaignDocuments'
import CampaignImages from './components/elements/CampaignImages'
import CampaignInspections from './components/elements/CampaignInspections'
import CaseStudies from './components/elements/CaseStudies'
import Comparables from './components/elements/Comparables'
import Contacts from './components/elements/Contacts'
import Container from './components/elements/Container'
import Counter from './components/elements/Counter'
import CustomSections from './components/elements/CustomSections'
import DataLoop from './components/elements/DataLoop'
import DynamicInputs from './components/elements/DynamicInputs'
import FormResponses from './components/elements/FormResponses'
import Gallery from './components/elements/Gallery'
import HashLink from './components/elements/HashLink'
import Iframe from './components/elements/Iframe'
import Image from './components/elements/Image'
import Input from './components/elements/Input'
import KeyFeatures from './components/elements/KeyFeatures'
import MapboxMap from './components/elements/MapboxMap'
import Quotes from './components/elements/Quotes'
import Reviews from './components/elements/Reviews'
import Team from './components/elements/Team'
import TextBlock from './components/elements/TextBlock'
import Timeline from './components/elements/Timeline'
import Video from './components/elements/Video'

const availableComponents = {
  agent: Agent,
  button: Button,
  buyerProfiles: BuyerProfiles,
  campaignDocuments: CampaignDocuments,
  campaignImages: CampaignImages,
  campaignInspections: CampaignInspections,
  campaignTimeline: Timeline,
  caseStudies: CaseStudies,
  comparables: Comparables,
  contacts: Contacts,
  container: Container,
  counter: Counter,
  customSections: CustomSections,
  dataArrayLoop: DataLoop,
  dynamicGrid: Container,
  dynamicInputs: DynamicInputs,
  formResponses: FormResponses,
  gallery: Gallery,
  hashLink: HashLink,
  iframe: Iframe,
  image: Image,
  input: Input,
  keyFeatures: KeyFeatures,
  mapboxMap: MapboxMap,
  quotes: Quotes,
  reviews: Reviews,
  team: Team,
  text: TextBlock,
  video: Video,
}

export function getAvailableComponents(options = {}){
  const components = { ...availableComponents }

  if (options.excludeComponent){
    delete components[options.excludeComponent]
  }

  return components
}

export default availableComponents
